import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Edit } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: theme.spacing(3),
        },
        edit: {
            display: 'flex',
            alignItems: 'center',
        },
        editButton: {
            cursor: 'pointer',
            marginLeft: '5px',
        },
    })
);

interface Props {
    styleBody?: React.CSSProperties;
    title: string;
    body: string | undefined | Array<string | undefined> | Date | number;
    isEditable?: boolean;
    onEditClick?: () => void;
}

const CardInfoItem = ({ styleBody, title, body, isEditable, onEditClick }: Props) => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            {isEditable ? (
                <Box className={classes.edit}>
                    <Typography variant="button">{title}</Typography>
                    <Edit className={classes.editButton} fontSize="small" onClick={onEditClick} />
                </Box>
            ) : (
                <Typography variant="button">{title}</Typography>
            )}
            <Typography variant="body1" style={styleBody}>{Array.isArray(body) ? body.join(' ') : body}</Typography>
        </Box>
    );
};

export default CardInfoItem;
